<template>
    <div
        class="vx-p-6 vx-bg-slate-300/30 vx-rounded-2xl vx-shadow-inner vx-border-solid vx-border-b vx-border-t-0 vx-border-x-0 vx-border-white vx-flex-col vx-gap-4 vx-flex"
    >
        <div>
            <div class="vx-font-bold vx-text-xs vx-text-slate-700 vx-mb-2">Status</div>
            <vx-box color="info" class="vx-p-4">
                <div class="vx-flex vx-flex-col vx-gap-3">
                    <div
                        v-for="statusOption in statusesOptions"
                        :key="statusOption.value"
                        class="vx-flex vx-gap-2 vx-items-center vx-text-sm vx-cursor-pointer"
                        :data-test="`status-${statusOption.value}`"
                        @click.prevent="filters.status = statusOption.value"
                        @keydown.space.prevent="filters.status = statusOption.value"
                        @keydown.enter.prevent="filters.status = statusOption.value"
                    >
                        <vx-radio :modelValue="filters.status === statusOption.value"></vx-radio>
                        {{ statusOption.label }}
                    </div>
                </div>
            </vx-box>
        </div>
        <div>
            <div class="vx-font-bold vx-text-xs vx-text-slate-700 vx-mb-2">Parent Team</div>
            <vx-selectable
                v-model="filters.parent_id"
                placeholder="-"
                :reduce="(option) => option.value"
                :loading="loadingParentTeams"
                :options="parentTeams"
                @search="searchParentTeams"
                :clearable="false"
                data-test="parent-teams-selectable"
            >
            </vx-selectable>
        </div>
        <div>
            <div class="vx-font-bold vx-text-xs vx-text-slate-700 vx-mb-2">Favorite</div>
            <vx-box color="info" class="vx-p-4">
                <div class="vx-flex vx-flex-col vx-gap-3">
                    <div
                        v-for="favoriteOption in favoriteOptions"
                        :key="favoriteOption.value"
                        class="vx-flex vx-gap-2 vx-items-center vx-text-sm vx-cursor-pointer"
                        @click.prevent="filters.is_favorite = favoriteOption.value"
                        @keydown.space.prevent="filters.is_favorite = favoriteOption.value"
                        @keydown.enter.prevent="filters.is_favorite = favoriteOption.value"
                    >
                        <vx-radio :modelValue="filters.is_favorite === favoriteOption.value"></vx-radio>
                        {{ favoriteOption.label }}
                    </div>
                </div>
            </vx-box>
        </div>
    </div>
</template>

<script setup>
import { VxBox, VxRadio, VxSelectable } from '@voxie/frontend-components';
import { ref } from 'vue';
import { useToasted } from '~/composables/useToasted';
import adminTeamsClient from '~/services/adminTeamsClient';
import debounce from '~/utils/debounce';

const toasted = useToasted();

const statusesOptions = [
    { label: 'All', value: undefined },
    { label: 'Active', value: 'active' },
    { label: 'Pending', value: 'pending' },
    { label: 'Suspended', value: 'suspended' },
    { label: 'Closed', value: 'closed' },
];
const favoriteOptions = [
    { label: 'All', value: undefined },
    { label: 'Yes', value: '1' },
    { label: 'No', value: '0' },
];

const filters = defineModel({
    default: () => ({}),
});

const parentTeams = ref([]);
const loadingParentTeams = ref();

const searchParentTeams = debounce((query) => {
    loadingParentTeams.value = true;

    adminTeamsClient
        .listTeams({
            is_parent: 1,
            query: query,
        })
        .then((response) => {
            parentTeams.value = response.data.data.map((team) => ({
                value: team.id,
                label: `${team.id} - ${team.name}`.trim(),
            }));
        })
        .catch((e) => {
            console.error(e);
            toasted.global.platform_error();
        })
        .finally(() => {
            loadingParentTeams.value = false;
        });
}, 300);

searchParentTeams();
</script>
